import {Stats} from "./Stats";

export const CardSettings = {
    width: 32,
    height: 32,
    spacing: 10
};

export enum CardType {
    INCREASE_STAT = 'INCREASE_STAT',
    CREATE_MONSTER = 'CREATE_MONSTER'
}

export enum StatType {
    SANCTUARY = 'SANCTUARY',
    FORGE = 'FORGE',
}

export enum MonsterType {
    SIMPLE = 'SIMPLE',
    BOSS = 'BOSS',
}

export interface CardConfig {
    type: CardType;
    statType?: StatType;
    monsterType?: MonsterType;
}

export function getCardSpriteName(cardConfig: CardConfig): string {
    if (cardConfig.type === CardType.INCREASE_STAT) {
        if (cardConfig.statType === StatType.SANCTUARY) {
            return 'card_sanctuary'
        }
        else if (cardConfig.statType === StatType.FORGE) {
            return 'card_forge'
        }
        else {
            throw new Error(`Unknown stat type: ${cardConfig.statType}`)
        }
    }
    else if (cardConfig.type === CardType.CREATE_MONSTER) {
        return 'card_simple'
    }
    else {
        throw new Error(`Unknown card type: ${cardConfig.type}`)
    }
}